import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "common-layout"
};
const _hoisted_2 = {
  class: "content-wrapper"
};
const _hoisted_3 = {
  key: 0,
  class: "my-main"
};
const _hoisted_4 = {
  key: 1,
  class: "full-screen-content"
};
import Nav from "@/components/Home/Nav.vue";
import Footer from "@/components/Home/Footer.vue";
export default /*@__PURE__*/_defineComponent({
  __name: 'Layout',
  setup(__props) {
    return (_ctx, _cache) => {
      const _component_el_header = _resolveComponent("el-header");
      const _component_router_view = _resolveComponent("router-view");
      const _component_el_main = _resolveComponent("el-main");
      const _component_el_footer = _resolveComponent("el-footer");
      const _component_el_container = _resolveComponent("el-container");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_container, {
        class: "container"
      }, {
        default: _withCtx(() => [!_ctx.$route.meta.hidNavFoo ? (_openBlock(), _createBlock(_component_el_header, {
          key: 0,
          class: "header"
        }, {
          default: _withCtx(() => [_createVNode(Nav)]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_el_main, {
          class: _normalizeClass(['main', {
            'full-screen': _ctx.$route.meta.fullScreen
          }]),
          style: _normalizeStyle([{
            minHeight: _ctx.$route.meta.hidNavFoo ? '100vh' : 'calc(100vh - 80px)'
          }, {
            marginTop: _ctx.$route.meta.hidNavFoo ? '0' : '140px'
          }])
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [!_ctx.$route.meta.fullScreen ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_router_view, null, {
            default: _withCtx(({
              Component
            }) => [(_openBlock(), _createBlock(_KeepAlive, null, [(_openBlock(), _createBlock(_resolveDynamicComponent(Component)))], 1024))]),
            _: 1
          })])) : (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_router_view)]))])]),
          _: 1
        }, 8, ["class", "style"]), !_ctx.$route.meta.hidNavFoo ? (_openBlock(), _createBlock(_component_el_footer, {
          key: 1,
          class: "footer"
        }, {
          default: _withCtx(() => [_createVNode(Footer)]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      })]);
    };
  }
});